<template>
  <v-toolbar
    id="main_toolbar"
    aria-label="main"
    fixed
    class="z11 elevation-0 pl-4 pr-0"
    :class="{
      collapse: toolbarHidden,
    }"
  >
    <v-toolbar-items>
      <!-- ! PRI LOGO -->
      <v-img
        class="pa-2"
        :class="[
          isHideAllButLocale ? '' : 'cursor-pointer',
          $vuetify.display.smAndDown ? 'mt-4' : 'mt-3',
        ]"
        src="../../assets/primerica-color-logo.svg"
        :height="isMobile ? '34px' : '40px'"
        :width="isMobile ? '161px' : '180px'"
        alt="Primerica Beta"
        @click="goToDashboardHome"
      />
      <!-- ! NAV ITEM -->
      <v-container class="hidden-md-and-down mt-1" v-if="!isMobileApp">
        <!-- ! NAV ITEMS -->
        <a
          v-if="!isHideAllButLocale"
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteDashboard() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          :aria-label="$t('L_home')"
          @click="nav.goToMyFinancialHome"
        >
          {{ $t('L_home') }}
        </a>
        <a
          v-if="!isHideAllButLocale"
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteTermLifeBenefits() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          :aria-label="$t('L_life_insurance')"
          @click="nav.termLifeAction"
        >
          {{ $t('L_life_insurance') }}
        </a>
        <a
          v-if="!isHideAllButLocale"
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteInvestments() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          :aria-label="$t('L_investment')"
          @click="nav.investmentsAction"
        >
          {{ $t('L_investment') }}
        </a>
        <a
          v-if="!isHideAllButLocale"
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteDebtSolutions() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          :aria-label="$t('L_debt')"
          @click.prevent="nav.debtAction"
        >
          {{ $t('L_debt') }}
        </a>
        <a
          v-if="hasAgents && !isHideAllButLocale"
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteMyRep() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          @click.prevent="nav.repAction"
        >
          {{ $t('L_my_rep') }}
        </a>
        <a
          v-if="!isHideAllButLocale"
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteDocuments() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          @click.prevent="nav.documentsAction(isMobileApp)"
          :aria-label="$t('L_my_document')"
        >
          {{ $t('L_my_document') }}
        </a>
        <a
          href="javascript:void(0)"
          class="px-2 cursor-pointer"
          :class="[
            nav.isRouteHelp() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
            isWideEnoughForFullMenu ? 'font-size--14' : 'font-size--14',
          ]"
          @click.prevent="helpAction"
          :aria-label="$t('L_help')"
          v-if="helpEnabled && !isHideAllButLocale"
        >
          {{ $t('L_help') }}
        </a>
      </v-container>
    </v-toolbar-items>
    <v-spacer></v-spacer>

    <!-- ! NOTIFICATION BELL (desktop) -->
    <div class="hidden-md-and-down mr-lg-4" v-if="!isHideAllButLocale">
      <v-icon @click.prevent="navigateToAlertAndNotifications" color="primary" :icon="mdiBell" />
      <sup class="redBadgeCircleSmall" v-if="hasNotificationWarning">
        <span class="warningTextInCircleSmall">!</span>
      </sup>
    </div>
    <!-- ! NOTIFICATION BELL (tablet and mobile) -->
    <div
      v-if="!isHideAllButLocale"
      class="hidden-lg-and-up mx-0"
      :class="[
        nav.isRouteAlertAndNotifications() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
      ]"
      @click.prevent="navigateToAlertAndNotifications"
    >
      <v-icon size="large" color="#233b52" :icon="mdiBell" />
      <sup class="redBadgeCircleLarge" v-if="hasNotificationWarning">
        <span class="warningTextInCircleLarge">!</span>
      </sup>
    </div>
    <!-- ! LOCALE TOGGLE -->
    <div class="mx-0 mx-sm-4 mx-md-4 mx-lg-6" v-if="languageFlag">
      <v-btn>
        <OnexLanguageSelector
          :locales="locales"
          id="language-selector"
          @localeChange="localChanged"
        />
      </v-btn>
    </div>

    <template v-slot:append>
      <!-- ! BADGE DROPDOWN -->
      <div class="hidden-md-and-down pa-4">
        <v-menu transition="slide-y-transition" v-if="!isMobileApp">
          <template #activator="{ props }">
            <a
              ref="menu"
              v-bind="props"
              href="javascript:void(0)"
              role="button"
              aria-label="Main Menu"
              aria-haspopup="true"
              class="circle_blue"
            >
              {{ userInitial }}
            </a>
          </template>
          <v-list ref="items">
            <v-list-item v-if="!isHideAllButLocale">
              <v-list-item-title
                tabindex="-1"
                role="button"
                @click.prevent="nav.accountAction"
                :class="[
                  nav.isRouteMyAccount() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass',
                  isWideEnoughForFullMenu ? 'font-size--16' : 'font-size--14',
                ]"
              >
                {{ $t('L_account_setting') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title role="button" tabindex="-1" @click="logout">
                {{ $t('L_sign_out') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- ! HAMBURGER MENU (tablet and mobile)-->
      <div class="hidden-lg-and-up pa-4" :class="isMobileApp ? 'hidehamburger' : ''">
        <a
          id="drawer_menu_open"
          href="javascript:void(0)"
          tabindex="0"
          role="button"
          aria-label="Mobile Navigation"
          v-if="!isMobileApp"
          :disabled="menuClickProcessing"
          @click.stop="navDrawer ? clickToCloseTheDrawer() : clickToOpenTheDrawer()"
        >
          <v-icon v-if="navDrawer" class="hamburger-menu" :icon="mdiClose" />
          <v-icon v-else class="hamburger-menu" :icon="mdiMenu" />
        </a>
      </div>
    </template>
  </v-toolbar>
</template>

<script lang="ts">
import { type ComponentOptions, defineComponent } from 'vue';
import { OnexLanguageSelector } from '@primerica/onex-ui-lib';
import { useGlobalStore } from '@/stores/global/global.store';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { mdiBell, mdiClose, mdiMenu } from '@mdi/js';
import { RouteNames } from '@/router/routeNames';
import { getNav } from '@/shared/navLogic';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { mapStores, mapState } from 'pinia';
import { COUNTRIES } from '@/shared/models/constants.models';
import { openInNewWindow } from '@/mixins/openNewWindow';

const componentOptions: ComponentOptions = {
  name: 'AppToolbar',
  components: {
    OnexLanguageSelector,
  },
  props: {
    navDrawer: {
      type: Boolean,
      required: true,
    },
    isHideAllButLocale: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [openInNewWindow],
  data: () => ({
    scrollPosition: 0,
    toolbarHidden: false,
    menuClickProcessing: false,
    mdiBell,
    mdiClose,
    mdiMenu,
    nav: getNav(),
    locales: [],
  }),
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    ...mapStores(useGlobalStore, useCustomerStore),
    languageFlag() {
      if (this.globalStore.containsFeature('LANGUAGE-TOGGLE')) {
        if (this.globalStore.localeLanguages?.length > 1) {
          return true;
        }
      }
      return false;
    },
    isMobile() {
      return this.$vuetify.display.mdAndDown;
    },
    isWideEnoughForFullMenu() {
      return this.$vuetify.display.width > 1284;
    },
    helpEnabled() {
      return window.appConfig.help.enabled;
    },
    isMobileApp() {
      return CapacitorFacade.isNativePlatform();
    },
    hasNotificationWarning(): boolean {
      return this.globalStore.alertsAndNotifications?.length > 0;
    },
    hasAgents() {
      return this.globalStore.agents?.length > 0;
    },
    userInitial() {
      let initial = '';
      if (
        this.customerStore.customerProfile?.firstName &&
        this.customerStore.customerProfile.firstName.length > 0
      ) {
        initial += this.customerStore.customerProfile.firstName[0].toUpperCase();
      }
      if (
        this.customerStore.customerProfile?.lastName &&
        this.customerStore.customerProfile.lastName.length > 0
      ) {
        initial += this.customerStore.customerProfile.lastName[0].toUpperCase();
      }
      return initial;
    },
    isCanadian() {
      return this.customerProfile?.country === COUNTRIES.CANADA;
    },
  },
  methods: {
    async localChanged(locale: string) {
      await this.globalStore.updateLocale(locale);
    },
    goToDashboardHome() {
      if (!this.isHideAllButLocale) {
        this.nav.goToMyFinancialHome();
      }
    },
    logout() {
      this.$emit('logout');
    },
    navigateToAlertAndNotifications() {
      this.$router.push({ name: RouteNames.ALERT_AND_NOTIFICATIONS });
    },
    focusMenuOpen() {
      document.getElementById('drawer_menu_open')?.focus();
    },
    clickToCloseTheDrawer() {
      this.$emit('clickToCloseTheDrawer');
    },
    clickToOpenTheDrawer() {
      this.$emit('clickToOpenTheDrawer');
    },
    async helpAction() {
      const globalStore = useGlobalStore();
      if (globalStore.containsFeature('HELP')) {
        // const helpUrl = await bff.getRightAnswersHelpUrl();
        // const encodedURL = encodeURI(helpUrl?.data?.URL);
        const newRightAnswersUrl =
          this.locale === 'fr_CA'
            ? window.appConfig.endpoints.frRightanswerslinkpostjune2025
            : window.appConfig.endpoints.rightanswerslinkpostjune2025;
        const isWeb = CapacitorFacade.isWeb();
        await this.openInNewWindow({
          url: newRightAnswersUrl,
          inappbrowser: !isWeb,
          target: 'RADashboardWinName',
        });
      }
    },
  },
  mounted() {
    if (this.isCanadian) {
      this.locales.push({ title: 'English (CAN)', value: 'en-CA' });
      this.locales.push({ title: 'French (CAN)', value: 'fr-CA' });
    } else {
      this.locales.push({ title: 'English (US)', value: 'en-US' });
      this.locales.push({ title: 'Español (US)', value: 'es-US' });
    }
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss">
.hidehamburger {
  display: none !important;
}

.notificationBellNoLocale {
  right: 80px;
}

.notificationBellWithLocale {
  right: 220px;
}

.redBadgeCircleSmall {
  width: 16px;
  background: red;
  position: relative;
  top: -20px;
  height: 15px;
  border-radius: 15px;
  left: -9px;
  display: inline-block;
}

.warningTextInCircleSmall {
  display: inline-block;
  position: relative;
  left: 6px;
  top: 7px;
  font-size: 14px;
  color: #fff;
  font-weight: 800;
}

.redBadgeCircleLarge {
  width: 15px;
  background: #f00;
  position: relative;
  top: -26px;
  height: 15px;
  border-radius: 15px;
  left: -11px;
  display: inline-block;
}

.warningTextInCircleLarge {
  display: flex;
  align-self: center;
  position: relative;
  left: 6px;
  top: 8px;
  font-size: 14px;
  color: #fff;
  font-weight: 800;
}

.circle_blue {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  padding: 13px 13px 13px 13px;
  background: #02579e;
  color: #ffffff !important;
  text-align: center;
  font:
    18px Arial,
    sans-serif;
  font-weight: 600;
  text-decoration: none;
}

a.heading_three {
  color: #656565 !important;
  cursor: text;
  text-decoration: none;
}

#header {
  h4.heading_four {
    &.inactive {
      opacity: 0.4;
    }

    a {
      font-weight: inherit !important;
      color: inherit !important;
    }
  }

  .hamburger-menu {
    font-size: 34px;
    color: #003261 !important;
  }

  nav {
    &#main_toolbar {
      transition: all 300ms ease-in-out;
      height: 130px;
      margin-top: -50px !important;
      padding-top: 54px;

      &.collapse {
        height: 0;
        margin-top: -56px !important;
      }
    }

    &.v-toolbar.mobile {
      background-image: linear-gradient(to bottom, #003466, #00284e);

      .v-toolbar__content {
        background: #ffffff;
        height: inherit !important;
        margin: 80px auto 0;
        padding: 0;
      }
    }
  }

  a.heading_four {
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    color: black !important;
  }

  .layout > a.heading_four.not-live {
    color: #656565 !important;
    cursor: text;
  }

  .z11 {
    z-index: 11;
  }

  .v-menu__content {
    position: fixed !important;
    right: 0 !important;
    left: auto !important;
    top: 80px !important;
    min-width: 200px !important;
  }

  .v-list {
    > div:hover {
      background-color: #f0f0f0;
      cursor: pointer;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }
}

.selectedMenuItemClass {
  color: #063562 !important;
  font-weight: 600;
  text-decoration: none;
}

.nonSelectedMenuItemClass {
  color: #000000 !important;
  font-weight: normal;
  text-decoration: none;
}
</style>
